var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/EstimationApi/EstimationRepo/EstimationCalculation.ts";
import * as t from 'io-ts';
import { ApiCallService } from '@gmini/api-call-service';
import { createPredicate } from '../createPredicate';
import { Id } from '../../Id';
import { Version } from '../../Version';
import { UserClassifierGroup } from '../../UserClassifierRepo';
import { ApiDomain } from '../../domain';
import { SimpleField } from './SimpleField'; // eslint-disable-next-line import/no-cycle

import { Estimation } from './Estimation';
import { ComplexField } from './ComplexField';
export var EstimationCalculation;

(function (_EstimationCalculation) {
  var domain = ApiDomain.domain('EstimationCalculation', {
    name: "domain",
    sid: "-4en62j"
  });
  var io = _EstimationCalculation.io = t.type({
    id: Id,
    groupId: Id,
    type: t.literal('EstimationCalculation'),
    simpleFields: t.array(SimpleField.io),
    parentEstimationId: Id,
    parentEstimationVersion: Version,
    complexFields: t.array(ComplexField),
    simpleFieldsProperties: t.array(UserClassifierGroup.Property.io),
    complexFieldsProperties: t.array(UserClassifierGroup.Property.io)
  });
  var is = _EstimationCalculation.is = createPredicate('EstimationCalculation');
  var updateFields = _EstimationCalculation.updateFields = ApiCallService.create({
    name: 'updateConditions',
    parentDomain: domain,
    result: io,
    getKey: ['estimationId', 'estimationVersion']
  });
  var Status = _EstimationCalculation.Status = t.union([t.literal('NotStarted'), t.literal('Started'), t.literal('InProgress'), t.literal('Finished'), t.literal('Error')]);
  var create = _EstimationCalculation.create = ApiCallService.create({
    name: 'create',
    parentDomain: domain,
    result: EstimationCalculation.io,
    getKey: ['estimationId', 'estimationVersion', 'groupId']
  });
  var remove = _EstimationCalculation.remove = ApiCallService.create({
    name: 'remove',
    parentDomain: domain,
    result: t.recursion('Estimation', function () {
      return Estimation.io;
    }),
    getKey: ['estimationId', 'estimationVersion', 'calculationId']
  });
  var ValidateFormulaResponse = _EstimationCalculation.ValidateFormulaResponse = t.type({
    isValid: t["boolean"]
  });
  var validateFormula = _EstimationCalculation.validateFormula = ApiCallService.create({
    result: ValidateFormulaResponse,
    name: 'validateFormula',
    getKey: ['formula'],
    parentDomain: domain
  });
})(EstimationCalculation || (EstimationCalculation = {}));